export default "__VITE_ASSET__3d9daa40__"